export const PencilIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3631 3.65172L12.843 2.17173C13.6241 1.39068 14.8904 1.39068 15.6715 2.17173L17.0857 3.58595C17.8667 4.36699 17.8667 5.63332 17.0857 6.41437L15.6057 7.89436M11.3631 3.65172L1.74742 13.2674C1.41535 13.5995 1.21072 14.0378 1.1694 14.5056L0.927315 17.2461C0.872545 17.8661 1.39141 18.385 2.01143 18.3302L4.75184 18.0881C5.21965 18.0468 5.658 17.8421 5.99007 17.5101L15.6057 7.89436M11.3631 3.65172L15.6057 7.89436"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
